var State = {
    filters: {
        functions: [],
        ecolabels: [],
        rciRange: [0, 100],
        ewgRange: [0, 10]
    },
    filterValues: {
        function: "",
        ecolabels: [],
        rci: [0, 100],
        ewg: [0, 10]
    },
    products: [

    ],
    subscribers: {},
    subscribe: function (event, method) {
        if (this.subscribers.hasOwnProperty(event)) {
            if (!this.subscribers[event]?.contains(method)) {
                this.subscribers[event].push(method);    
            }
        } else {
            this.subscribers[event] = [method];
        }
    },
    unsubscribe: function (event, method) {
        if (this.subscribers.hasOwnProperty(event)) {
            const index = this.subscribers[event].findIndex(x => x === method);
            if (index !== -1) {
                this.subscribers[event].splice(index, 1);
            }
        }
    },
    trigger: function (event, value) {
        if (this.subscribers.hasOwnProperty(event)) {
            this.subscribers[event].map(m => m(value));
        }
    }
};
export default State;